(function () {
  'use strict';

  var LINK_SELECTOR = '.jdgm-carousel-item__product[href]';

  function normalizedLocaleRoot() {
    var script = document.getElementById('sks-locale-preserving-app-links');
    var root = script && script.getAttribute('data-locale-root');

    if (!root || root === '/') {
      return '';
    }

    return '/' + String(root).replace(/^\/+|\/+$/g, '');
  }

  function localizeLink(anchor) {
    var localeRoot = normalizedLocaleRoot();

    if (!localeRoot) {
      return;
    }

    var url;

    try {
      url = new URL(anchor.getAttribute('href'), window.location.origin);
    } catch (error) {
      return;
    }

    if (url.origin !== window.location.origin) {
      return;
    }

    if (url.pathname === localeRoot || url.pathname.indexOf(localeRoot + '/') === 0) {
      return;
    }

    var localizedPath = localeRoot + (url.pathname === '/' ? '' : url.pathname);
    anchor.setAttribute('href', localizedPath + url.search + url.hash);
  }

  function localizeLinksWithin(root) {
    if (!root || root.nodeType !== 1) {
      return;
    }

    if (root.matches && root.matches(LINK_SELECTOR)) {
      localizeLink(root);
    }

    if (root.querySelectorAll) {
      Array.prototype.forEach.call(root.querySelectorAll(LINK_SELECTOR), localizeLink);
    }
  }

  function start() {
    localizeLinksWithin(document.documentElement);

    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.type === 'attributes') {
          localizeLinksWithin(mutation.target);
          return;
        }

        Array.prototype.forEach.call(mutation.addedNodes, localizeLinksWithin);
      });
    });

    observer.observe(document.body, {
      attributes: true,
      attributeFilter: ['href'],
      childList: true,
      subtree: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
